import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const COUNTRY_BASE_PATH = '/Country';

export const countryEndpoints = {
  list: () => buildEndpoint(COUNTRY_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${COUNTRY_BASE_PATH}/:id`, { id }),
} as const;

export default countryEndpoints;
